import styled from 'styled-components'

import Text from 'antd/lib/typography/Text'

import { Card as CardComp } from 'src/components/Ant'

export const Card = styled(CardComp)`
  margin-bottom: 16px;
`

export const DateTime = styled(Text)`
  font-size: smaller;
  font-style: italic;
`
export const Traveler = styled(Text)`
  font-size: smaller;
`
